import { useFinance } from '../../../contexts';
import { RangeDatePicker } from './RangeDatePicker';
import styles from './DateFilter.module.css';

export function DateFilter() {
    const { applyDateFilter, dateFilter } = useFinance();
    const hasSelectedDates = Boolean(dateFilter.dataInicio || dateFilter.dataFim);

    const handleClear = () => {
        applyDateFilter({ dataInicio: '', dataFim: '' });
    };

    return (
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem' }}>
            <RangeDatePicker
                key={`${dateFilter.dataInicio}-${dateFilter.dataFim}`}
                initialStart={dateFilter.dataInicio}
                initialEnd={dateFilter.dataFim}
                onChange={(start, end) => applyDateFilter({ dataInicio: start, dataFim: end })}
                onClear={handleClear}
            />
            <button
                type="button"
                className={styles.clearButton}
                onClick={handleClear}
                disabled={!hasSelectedDates}
            >
                Limpar datas
            </button>
        </div>
    );
}
